import axios from "axios";
import Select from "react-dropdown-select";
import Swal from "sweetalert2";
import { MajorColorArrays } from "../../constants";

const STLOCCASSIONSOPTIONS = [
  "Office",
  "College",
  "Travel Airport",
  "Evening Dates",
  "Afternoon Hangouts",
  "Sports",
  "Party",
  "Formal Events",
  "Home",
]

const STLASPIRETOLOOKOPTIONS = [
  "Look Classy",
  "Look Athletic",
  "Look Adventures",
  "Look Creative",
  "Look Minimalist",
  "Look Trendiest",
  "Look Charming",
  "Look Professional",
  "Look Chill",
]

const STLWEATHEROPTIONS = [
  "For a Hot Humid city",
  "For a Cold city",
]

const getValues = (valuesToUpdate, imageData, fieldName) => {
  const values = valuesToUpdate && valuesToUpdate[fieldName] ? valuesToUpdate[fieldName].map(v => ({ value: v, label: v })) : (imageData && imageData[fieldName] ? imageData[fieldName].map(v => ({ value: v, label: v })) : [])
  return values
}

const STLValuesUpdate = ({ imageData, valuesToUpdate, setValuesToUpdate, type = 'social' }) => {


  const changeParams = (next, fieldName) => {
    setValuesToUpdate(prev => {
      const nextValues = { ...prev, [fieldName]: next.map(v => v.value) }
      return nextValues
    })
  }



  return <div className="border-4 border-red-400 w-full px-4">

    <div>
      <div className="border-b py-2">
        <h3>Occassion</h3>
        <div className="flex justify-between">
          <div>
            <Select
              placeholder="Select Occassion"
              values={getValues(valuesToUpdate, imageData, 'STLOccassions')}
              options={STLOCCASSIONSOPTIONS.map(v => ({ label: v, value: v }))}
              multi
              onChange={(next) => {
                changeParams(next, 'STLOccassions')
              }}
            />
          </div>

          {valuesToUpdate && valuesToUpdate.STLOccassions ? <div>
            <div className="font-semibold">Occassions To Update</div>

            <ol>{valuesToUpdate.STLOccassions.map((v, i) => (<li key={v}>{i + 1}. {v}</li>))}</ol>
          </div> : null}


        </div>
      </div>
      <div className="border-b py-2">
        <h3>ASPIRE TO LOOK</h3>
        <div className="flex justify-between">
          <div>
            <Select
              placeholder="Select "
              values={getValues(valuesToUpdate, imageData, 'STLAspireToLook')}
              options={STLASPIRETOLOOKOPTIONS.map(v => ({ label: v, value: v }))}
              multi
              onChange={(next) => {
                changeParams(next, 'STLAspireToLook')
              }}
            />
          </div>

          {valuesToUpdate && valuesToUpdate.STLAspireToLook ? <div>
            <div className="font-semibold">Aspire Look To Update</div>

            <ol>{valuesToUpdate.STLAspireToLook.map((v, i) => (<li key={v}>{i + 1}. {v}</li>))}</ol>
          </div> : null}


        </div>
      </div>
      <div className="border-b py-2">
        <h3>WEATHER</h3>
        <div className="flex justify-between">
          <div>
            <Select
              placeholder="Select "
              values={getValues(valuesToUpdate, imageData, 'STLWeather')}
              options={STLWEATHEROPTIONS.map(v => ({ label: v, value: v }))}
              multi
              onChange={(next) => {
                changeParams(next, 'STLWeather')
              }}
            />
          </div>

          {valuesToUpdate && valuesToUpdate.STLWeather ? <div>
            <div className="font-semibold">Weather To Update</div>

            <ol>{valuesToUpdate.STLWeather.map((v, i) => (<li key={v}>{i + 1}. {v}</li>))}</ol>
          </div> : null}


        </div>
      </div>
    </div>



  </div>
}

export default STLValuesUpdate;
